// Angular
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
// Libraries
import { Subscription } from 'rxjs';
// Afidium
import { ICheckboxFieldSpecs, IDateFieldSpecs } from '../interfaces/field-specs';
import { tap } from 'rxjs/operators';

export interface IDateRangeFieldSpecs {
    [key: string]: IDateFieldSpecs;
}

interface IDateRangeValue {
    min: Date;
    max: Date;
}


@Component({
    selector: 'date-range-field',
    template: `
        <div class="flex-1 sep-top" *ngIf="missingDateFieldConfig">
            <checkbox-field [fieldConfig]="missingDateFieldConfig" (onChange)="toggleDateFields($event)"></checkbox-field>
        </div>
        <div *ngFor="let key of fieldConfigKeys; let i = index"
             class="flex-1 sep-top"
             [class.sep-left]="i !== 0 || missingDateFieldConfig">
            <date-field class="e2e-date-{{key}}"
                        [fieldConfig]="fieldConfig[key]"
                        [isInternalError]="isInternalError"
                        [onlyOneMonth]="onlyOneMonth"></date-field>
        </div>
    `,
    styles: [`
        :host {
            display: flex;
        }
    `]
})

export class DateRangeComponent implements OnInit, OnChanges, AfterViewInit {

    /** Optional. If present, we will display a "Missing date" checkbox before date fields. */
    @Input()
    public missingDateFieldConfig?: ICheckboxFieldSpecs;

    @Input()
    public fieldConfig: IDateRangeFieldSpecs;

    @Input()
    public formGroup: FormGroup;

    @Input()
    public onlyOneMonth: boolean;

    @Input()
    public isInternalError: boolean;

    public errors: any = {};

    public fieldConfigKeys: string[];
    private subscription: Subscription;

    public ngOnInit(): void {

        this.fieldConfigKeys = Object.keys(this.fieldConfig).map((key: string) => key);

        this.subscription = this.formGroup
            .valueChanges
            .pipe(
                tap(
                    (dateRangeValue: IDateRangeValue) => {
                        // we're assuming the first key is the begin date item and the last the end date
                        const beginKey: string = this.fieldConfigKeys[0];
                        const endKey: string = this.fieldConfigKeys[1];
                        if (dateRangeValue.max instanceof Date) {
                            this.fieldConfig[beginKey].maxDate = dateRangeValue.max;
                        }
                        if (dateRangeValue.min instanceof Date) {
                            this.fieldConfig[endKey].minDate = dateRangeValue.min;
                        }
                    }
                )
            )
            .subscribe();



    }

    public ngAfterViewInit(): void {
        if (this.missingDateFieldConfig) {
            // enable or disable date fields according to initial form value
            this.toggleDateFields(this.formGroup.get(this.missingDateFieldConfig.formControlName).value);
            // #27557: didn't find a better way achieve
            this.missingDateFieldConfig.formGroup.get(this.missingDateFieldConfig.formControlName).enable();
            this.missingDateFieldConfig ={
                ...this.missingDateFieldConfig,
                disabled : false
            };
        }
    }

    public validateAllFormFields(formGroup: FormGroup): void {
        Object.keys(formGroup.controls)
            .forEach((field: string) => {
                const formField: AbstractControl = formGroup.get(field);
                formField.updateValueAndValidity();
            });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.validateAllFormFields(this.formGroup);
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public toggleDateFields(disableFields: boolean): void {
        Object.values(this.fieldConfig).forEach((fieldSpec: IDateFieldSpecs) => {
            fieldSpec.disabled = disableFields;
            if (disableFields) {
                this.formGroup.get(fieldSpec.formControlName).disable();
            } else {
                this.formGroup.get(fieldSpec.formControlName).enable();
            }
        });
    }
}
